import createIcon from '../../createIcon';

/**
 * @component @name RemoveDone
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMS43OTUgMTEuOTk0OUw3LjM3NSAxNy41ODQ5TDUuOTY1IDE4Ljk5NDlMMC4zNzUgMTMuNDA0OUwxLjc5NSAxMS45OTQ5Wk0yLjI0NSA0LjIxNDkzTDEyLjkwNSAxNC44ODQ5TDExLjYyNSAxNi4xNjQ5TDcuNDQ1IDExLjk5NDlMNi4wMzUgMTMuNDA0OUwxMS42MjUgMTguOTk0OUwxNC4zMTUgMTYuMzA0OUwxOS4yMDUgMjEuMTk0OUwyMC42MTUgMTkuNzg0OUwzLjY1NSAyLjgwNDkzTDIuMjQ1IDQuMjE0OTNaTTE3LjE0NSAxMy40ODQ5TDIzLjYyNSA2Ljk5NDkzTDIyLjIwNSA1LjU4NDkzTDE1LjcyNSAxMi4wNjQ5TDE3LjE0NSAxMy40ODQ5Wk0xNy45NjUgNi45OTQ5M0wxNi41NTUgNS41ODQ5M0wxMi45MDUgOS4yNDQ5M0wxNC4zMTUgMTAuNjU0OUwxNy45NjUgNi45OTQ5M1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RemoveDone = createIcon('RemoveDone', [
  [
    'path',
    {
      d: 'M1.795 11.9949L7.375 17.5849L5.965 18.9949L0.375 13.4049L1.795 11.9949ZM2.245 4.21493L12.905 14.8849L11.625 16.1649L7.445 11.9949L6.035 13.4049L11.625 18.9949L14.315 16.3049L19.205 21.1949L20.615 19.7849L3.655 2.80493L2.245 4.21493ZM17.145 13.4849L23.625 6.99493L22.205 5.58493L15.725 12.0649L17.145 13.4849ZM17.965 6.99493L16.555 5.58493L12.905 9.24493L14.315 10.6549L17.965 6.99493Z',
      key: 'yxnzes',
    },
  ],
]);

export default RemoveDone;
